module.exports = __webpack_public_path__ + "centric-card-bottom-right.29ohV17I.png";